/*
This service is based on code originally implemented in DUOP v2.
*/
import { Injectable } from "@angular/core";
import { ExcelService } from "dspx-core";
import { API_ENDPOINTS } from "../constants/api-endpoints.constants";
import { ExportToDataTablesRequest } from "../interfaces/export-to-data-tables-request.interface";
import { ExportToDataTablesResponse } from "../interfaces/export-to-data-tables-response.interface";
import { RateGridFilterRequest } from "../interfaces/rate-grid-filter-request.interface";
import { AppDataService } from "./app-data.service";

@Injectable({
  providedIn: 'root'
})
export class ExcelExportService {
  constructor(
    private appDataService: AppDataService,
    private excelService: ExcelService) {
  }

  exportCareAllowanceRatesToCsv(request: RateGridFilterRequest): void {
    this.appDataService.getCsv(API_ENDPOINTS.careAllowanceRate.export, request, 'Care Allowance Rates');
  }

  exportCareAllowanceRateUploadTemplate(): void {
    this.appDataService.getCsv(API_ENDPOINTS.careAllowanceRate.getUploadTemplate, null, 'Care Allowance Rates');
  }

  downloadErrorLogBulkUpload(request: ExportToDataTablesRequest): void {
    this.exportToXlsx(API_ENDPOINTS.concessionsApplicationBulkUpload.downloadErrorLog, request);
  }

  private exportToXlsx(apiEndpoint: string, request: ExportToDataTablesRequest): void {
    const onSuccess = (response: ExportToDataTablesResponse) => {
      const fileName = `${response?.dataSetFriendlyName}.xlsx`;
      const workSheetInfos = response?.dataTables?.map(dataTable => ({ workSheetName: dataTable?.tableName, workSheetData: dataTable?.data })) ?? [];
      this.excelService.writeWorkBookToFile(fileName, workSheetInfos);
    }
    this.appDataService.getDataTableSet(apiEndpoint, request, onSuccess);
  }
}
